import React, { useLayoutEffect, useRef } from 'react';
import { useWindowSize } from 'usehooks-ts';
import { Caption, Circle, Line, Section, Title } from './styled';
import { isInViewport } from './helpers/isInViewport';
export function StepHeader({ title, caption, isLast, $legendProps, orientation, activeStepIndex, stepIndex, isSkipped, breakpoint, }) {
    const stepRef = useRef(null);
    const screen = useWindowSize();
    const isAutoHorizontal = orientation === 'auto' && screen.width >= breakpoint;
    const isHorizontal = orientation === 'horizontal' || isAutoHorizontal;
    useLayoutEffect(() => {
        if (isHorizontal || !stepRef.current || stepIndex !== activeStepIndex) {
            return;
        }
        if (!isInViewport(stepRef.current)) {
            stepRef.current.scrollIntoView();
        }
    }, [isHorizontal, stepIndex, activeStepIndex, stepRef]);
    const isActive = stepIndex === activeStepIndex;
    return (React.createElement(Section, Object.assign({}, $legendProps, { as: ($legendProps === null || $legendProps === void 0 ? void 0 : $legendProps.onClick) ? 'button' : 'div', ref: stepRef, "data-stb-step-index": stepIndex, tabIndex: -1, "aria-current": isActive ? 'step' : undefined }),
        React.createElement(Circle, { "$completed": activeStepIndex > stepIndex, "$active": isActive, "$skipped": isSkipped }, stepIndex + 1),
        React.createElement(Title, null,
            React.createElement("p", { className: isActive ? 'h3' : '' }, title)),
        React.createElement(Caption, null, caption),
        !isLast && isHorizontal && React.createElement(Line, null)));
}
